import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCredits from '../reducers/credits.reducers';
export const selectCreditsState = createFeatureSelector<fromCredits.State>('credits');
export const selectUserCredits = createSelector(
  selectCreditsState,
  (state: fromCredits.State) => state.credits
);
export const selectCreditsErrorMessage = createSelector(
  selectCreditsState,
  (state: fromCredits.State) => state.errorMessage
);
export const selectIsCreditsLoading = createSelector(
  selectCreditsState,
  (state: fromCredits.State) => state.isLoading
);
